export default __webpack_public_path__ + "static/media/city-hall-elearning-negative.85bb90d6.svg";